// @ts-check

/*
    Simplified dispatcher: just a registry of callbacks, à la Flux/React.
    Try to maintain a single direction: state change -> dispatcher -> store -> ui

*/

import flyd from "flyd"
import debounceTime from "flyd-debouncetime"
import filter from "flyd/module/filter"

// import { makeType } from "../core/types";
// import { initLog } from "../core/base";

import { makeType, initLog } from "../core/base"

const proto = {
    name: "Dispatcher",

    initLog,

    initialize() {
        this.initLog ()
        // this.log.enable();
        // this.log.info ("initialized", this.log)
        this.stream = debounceTime (500, flyd.stream ())
    },

    dispatch(payload) {
        // this.log.info (`dispatching: ${payload.type}`, payload)
        this.stream (payload)
        // this.subject.next(payload);
    },

    send(payload) {
        this.dispatch (payload)
    },

    map(callback) {
        // this.log.info ("registering callback:", callback)

        return this.stream.map (callback)
    },

    filter(condition) {
        return filter (condition, this.stream)
    },

    register(callback) {
        return this.map (callback)
    }
}

export const Stream = makeType (proto)

// dispatcher is a singleton
const Dispatcher = new Stream ()

export default Dispatcher
